<script setup lang="ts">
import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useDayjs } from '@shared/lib/format'
import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { ModalDefault } from '@shared/ui/modals'

import { useOrderStore } from '../../model/store'

defineOptions({
  name: 'ModalOrderPaymentChangelog',
})

const COLUMNS = ['ID', 'Discipline id', 'Instance', 'Action', 'Field', 'Value', 'Old value', 'Created at']

const orderStore = useOrderStore()
const dayjs = useDayjs()

const refPayment = computed(() => orderStore.getChangelogPayment)

const formatDate = (value: string): string => dayjs(value).format(DateFormat.KanbanDate)

const close = (): void => {
  orderStore.setChangelogPayment(null)
}
</script>

<template>
  <ModalDefault
    :show="!!refPayment"
    title="Changelog"
    is-close-button
    @click:overlay="close"
    @click:close="close"
  >
    <div class="modal-order-payment-changelog">
      <AppTable
        class="rounded-table"
        :paginated="false"
      >
        <template #head>
          <AppTr>
            <AppTh
              v-for="column in COLUMNS"
              :key="column"
            >
              <AppText
                name="body1-medium"
                color="slate-900"
              >
                {{ column }}
              </AppText>
            </AppTh>
          </AppTr>
        </template>
        <template #body>
          <AppTr
            v-for="change in refPayment?.changelog ?? []"
            :key="change.id"
          >
            <AppTd class="medium">
              <AppText name="body1">
                {{ change.id }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText name="body1">
                {{ change.discipline_id || '-' }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText name="body1">
                {{ change.instance_type }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText name="body1">
                {{ change.action }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText name="body1">
                {{ change.field }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText name="body1">
                {{ change.value }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText name="body1">
                {{ change.old_value }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText name="body1">
                {{ formatDate(change.created_at) }}
              </AppText>
            </AppTd>
          </AppTr>
        </template>
      </AppTable>
    </div>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalOrderPaymentChangelog.scss" />
